import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RightMenuService {
  private menuOpenSignal = signal<boolean>(false);
  private activeComponentSignal = signal<string>('');

  // Expose read-only signals
  readonly menuOpen = this.menuOpenSignal.asReadonly();
  readonly activeComponent = this.activeComponentSignal.asReadonly();

  openMenu(component: string) {
    this.activeComponentSignal.set(component);
    this.menuOpenSignal.set(true);
  }

  closeMenu() {
    this.menuOpenSignal.set(false);
    this.activeComponentSignal.set('');
  }
}
